import vDataTable from './DataTable';

export { vDataTable };



// WEBPACK FOOTER //
// ./src/baseComponents/components/DataTable/index.js